import "./styles/main.scss";

document.addEventListener("alpine:init", () => {
	Alpine.data("wp_block_d3_security_tabs_under", () => ({
		$tabs: null,

		currentTab: 0,

		$currentVideoElement: null,

		$allVideoElements: null,

		targetElement: null,

		setActive(currentTab) {
			this.currentTab = currentTab;

			this.$tabs.forEach(($tab, index) => {
				$tab.classList.toggle("is-active", index + 1 === currentTab);
			});

			// Set all the 0 and play
			this.$allVideoElements.forEach(($videoElement, index) => {
				$videoElement.currentTime = 0;
				$videoElement.play();
			});

			this.$currentVideoElement = this.$el.querySelector(".wp-block-d3-security-tabs-item.is-active > div .wp-block-group video");

			// Set only current active to start and play
			if(this.$currentVideoElement != null){
				this.$currentVideoElement.currentTime = 0;
				this.$currentVideoElement.play();
			}

		},

		init() {

			this.$tabs = this.$el.querySelectorAll(".tab-labels > div");

			this.$allVideoElements = this.$el.querySelectorAll(".wp-block-d3-security-tabs-item > div .wp-block-group video");

			this.$tabs.forEach(($tab, index) => {
				$tab.addEventListener("click", () => {
					this.setActive(index + 1);
				});
			});

			// Set a mutation observer on the tabs to see when it is visible in the window
			this.targetElement = this.$el;

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						const target = mutation.target;
						if (target.classList.contains('is-visible')) {
							// When it is visible cancel observer and set the active tab.
							observer.disconnect();
							this.setActive(1);
						}
					}
				});
			});

			observer.observe(this.targetElement.parentElement, {
				attributes: true,
				attributeFilter: ['class']
			});
		},

	}));
});
